module.exports = __webpack_public_path__ + "media/application/images/2018/2018-dir-lock-17bccb99e5d54591503957935606d352.svg";